import { BoxProps } from '@hover/blueprint';
import React from 'react';

import { Button } from 'src/shared/components';

import { List } from '../List';

interface PillListProps extends BoxProps {
  title: string;
  items: string[];
  selected?: string;
  onPress: (id: string) => void;
}

const PillList = ({
  onPress,
  selected,
  title,
  items,
  ...props
}: PillListProps) => (
  <List title={title} {...props}>
    {items.map(item => (
      <Button
        fill={selected === item ? 'solid' : 'outline'}
        key={item}
        marginRight={200}
        onPress={() => onPress(item)}
      >
        {item}
      </Button>
    ))}
  </List>
);

export { PillList };
